import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { NewLooseCustomerRecipeInput } from './NewLooseCustomerRecipeInput';
import { NewLooseCustomerRecipeOutput } from './NewLooseCustomerRecipeOutput';

export class NewLooseCustomerRecipeService extends HttpServiceBase {

  handle = (input: NewLooseCustomerRecipeInput): Promise<Result<NewLooseCustomerRecipeOutput> | null> => {
    const promise = this.http.post<Result<NewLooseCustomerRecipeOutput>, NewLooseCustomerRecipeInput>(`${this.baseUrlSislogApi}/v2/customer-recipe/loose`, input);
    return promise;
  }
}